import { envStorage } from "@/utils/envCache";

import zuuAichatbotLogoUrl from "@/assets/HkaiLogin/zuu_aichatbot.png";

export const SOURCE_SYSTEM_STORAGE_KEY = "sourceSystem";
export const DEFAULT_SOURCE_SYSTEM = "default";
const CHATBOT_HOSTNAME = "chat.lifeplustools.com";
const BEEFIN_HOSTNAME = "beefin.tech";

export interface SourceSystemConfig {
  code: string;
  title: string;
  logoUrl?: string;
}

export const sourceSystemConfigMap: Record<string, SourceSystemConfig> = {
  [DEFAULT_SOURCE_SYSTEM]: {
    code: DEFAULT_SOURCE_SYSTEM,
    title: "BeeFintech AI",
  },
  chatbot: {
    code: "chatbot",
    title: "Chatbot",
  },
  "zuu-wxapp": {
    code: "zuu-wxapp",
    title: "芙莉莲（AI ChatBot）",
    logoUrl: zuuAichatbotLogoUrl,
  },
};

export function normalizeSourceSystem(sourceSystem?: string | null): string {
  if (!sourceSystem)
    return DEFAULT_SOURCE_SYSTEM;

  return sourceSystemConfigMap[sourceSystem] ? sourceSystem : DEFAULT_SOURCE_SYSTEM;
}

export function getSourceSystemConfig(sourceSystem?: string | null): SourceSystemConfig {
  return sourceSystemConfigMap[normalizeSourceSystem(sourceSystem)];
}

function isHostname(hostname: string | undefined, target: string): boolean {
  return hostname === target || Boolean(hostname?.endsWith(`.${target}`));
}

function getCurrentHostname(): string {
  return typeof window === "undefined" ? "" : window.location.hostname;
}

export function getBrandConfigForHost(
  sourceSystem?: string | null,
  hostname = getCurrentHostname()
): SourceSystemConfig {
  if (isHostname(hostname, BEEFIN_HOSTNAME)) {
    return getDefaultSourceSystemConfig();
  }

  if (isHostname(hostname, CHATBOT_HOSTNAME)) {
    return sourceSystem === "zuu-wxapp"
      ? getSourceSystemConfig(sourceSystem)
      : sourceSystemConfigMap.chatbot;
  }

  return getSourceSystemConfig(sourceSystem);
}

export function getDefaultBrandConfigForHost(
  hostname = getCurrentHostname()
): SourceSystemConfig {
  return getBrandConfigForHost(null, hostname);
}

export function getDefaultSourceSystemConfig(): SourceSystemConfig {
  return sourceSystemConfigMap[DEFAULT_SOURCE_SYSTEM];
}

export function saveSourceSystem(sourceSystem?: string | null): SourceSystemConfig {
  const config = getBrandConfigForHost(sourceSystem);
  envStorage.setItem(SOURCE_SYSTEM_STORAGE_KEY, config.code);
  return config;
}

export function getSavedSourceSystemConfig(): SourceSystemConfig {
  return getBrandConfigForHost(envStorage.getItem(SOURCE_SYSTEM_STORAGE_KEY));
}
